import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function SpacingContainer({ children }, { vertical }) {
  return (
    <div className={classNames('header-spacing-container collection-lead__header-spacing-container')}>
      <div
        className={classNames(
          'pv7 pv8-m',
          { 'pt6 pt6-m': vertical === 'today' },
        )}
      >
        {children}
      </div>
    </div>
  );
}

SpacingContainer.propTypes = {
  children: ChildrenPropType,
};

SpacingContainer.defaultProps = {
  children: null,
};

SpacingContainer.contextTypes = {
  vertical: PropTypes.string,
};

export default SpacingContainer;
